import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import useAxiosPrivate from "./useAxiosPrivate";
import AdsAPIs from "../apiRoutes/Ads";
import { GET_META_CAMPAIGNS_QUERY_KEY } from "../utils/constants/queryKeys";

const EMPTY = [];

/** One ad account's Meta campaigns, cached for 5 minutes, with each campaign's status by id. */
export default function useMetaCampaigns({ adAccountId }) {
  const axiosPrivate = useAxiosPrivate();
  const { data: campaigns = EMPTY, isLoading } = useQuery({
    queryKey: [...GET_META_CAMPAIGNS_QUERY_KEY, adAccountId],
    queryFn: () =>
      AdsAPIs.listMetaCampaigns({ axiosPrivate, ad_account_id: adAccountId }),
    enabled: !!adAccountId,
    staleTime: 5 * 60 * 1000,
  });
  const statusById = useMemo(
    () =>
      Object.fromEntries(
        campaigns.map((c) => [c.id, String(c.status || "").toUpperCase()])
      ),
    [campaigns]
  );
  return { campaigns, isLoading, statusById };
}
